/* eslint-disable @typescript-eslint/no-explicit-any */
import { Theme } from "@mui/material";
import { colors } from "./colors";
import theme from "./default";

export const lightTheme: Theme = {
  ...theme,
  palette: {
    ...theme.palette,
    mode: "light",
    background: {
      default: colors.white,
      paper: colors.capuccino
    },
    text: {
      primary: colors.black,
      secondary: colors.darkGrey,
      disabled: colors.lightGrey
    }
  },
  components: {
    ...theme.components,
    MuiOutlinedInput: {
      ...theme.components?.MuiOutlinedInput,
      styleOverrides: {
        ...theme.components?.MuiOutlinedInput?.styleOverrides,
        notchedOutline: {
          ...(theme.components?.MuiOutlinedInput?.styleOverrides?.notchedOutline as any),
          borderColor: colors.brown
        }
      }
    }
  }
};
